<button class="btn btn-link me-3 mb-2" [attr.data-identifier]="'organization-site-filter-toggle'"
        (click)="showFilters = !showFilters">
	<i class="fa fa-sliders"></i>
	{{ showFilters ? 'Hide' : 'All' }} Filters
</button>
<ng-container *ngIf="showFilters">
	<button class="btn btn-link me-3 mb-2" [attr.data-identifier]="'organization-site-filter-apply'"
	        (click)="applyFilters()">Apply Filters
	</button>
	<button class="btn btn-link me-3 mb-2" [attr.data-identifier]="'organization-site-filter-clear'"
	        (click)="clearFilters()">Clear All
	</button>
	<div class="d-flex flex-wrap gap-3 mb-2">
		<lib-filter-pill label="Organization Status">
			<div class="input-filter-group">
				<ng-select [items]="organizationStatusOpts"
				           [(ngModel)]="selectedOrganizationStatusOpt"
				           bindLabel="label"
				           bindValue="value"
				           [attr.data-identifier]="'organization-site-filter-status-select'"
				           placeholder="Any">
				</ng-select>
			</div>
		</lib-filter-pill>
		<lib-filter-pill label="Belongs to Organization">
			<div class="input-filter-group">
				<ng-select [items]="belongsToOrganizationOpts"
				           [(ngModel)]="selectedBelongsToOrganizationOpt"
				           bindLabel="label"
				           bindValue="value"
				           [attr.data-identifier]="'organization-site-filter-belongs-select'"
				           placeholder="Any">
				</ng-select>
			</div>
		</lib-filter-pill>
		<lib-filter-pill label="Auto-migrate">
			<div class="input-filter-group">
				<ng-select [items]="autoMigrateOpts"
				           [(ngModel)]="selectedAutoMigrateOpt"
				           bindLabel="label"
				           bindValue="value"
				           [attr.data-identifier]="'organization-site-filter-migrate-select'"
				           placeholder="Any">
				</ng-select>
			</div>
		</lib-filter-pill>
		<lib-filter-pill label="Pod">
			<div class="input-filter-group">
				<ng-select [items]="(pods$ | async) ?? []"
				           [searchable]="false"
				           [(ngModel)]="selectedPodOpt"
				           (open)="focusPodSearchInput()"
				           [attr.data-identifier]="'organization-site-filter-pod-select'"
				           placeholder="Any">
					<ng-template ng-header-tmp>
						<input #podSearchInput
						       type="text"
						       placeholder="Search"
						       (input)="onPodSearchInput($event)"/>
					</ng-template>
				</ng-select>
			</div>
		</lib-filter-pill>
		<lib-filter-pill label="Days in Organization">
			<div class="input-filter-group">
				<ng-select [items]="daysInOrganizationOpts"
				           [(ngModel)]="selectedDaysInOrganizationOpt"
				           bindLabel="label"
				           bindValue="value"
				           [attr.data-identifier]="'organization-site-filter-days-in-org-select'"
				           placeholder="Any">
				</ng-select>
			</div>
		</lib-filter-pill>
		<lib-filter-pill label="Planned Preconfigure Date">
			<div class="input-filter-group">
				<ng-select [items]="migrationDateFilterOpts"
				           [(ngModel)]="selectedPreconfigDateFilterOpt"
				           bindLabel="label"
				           bindValue="value"
				           [attr.data-identifier]="'organization-site-filter-preconfig-date-select'"
				           placeholder="Any">
				</ng-select>
			</div>
		</lib-filter-pill>
		<lib-filter-pill label="Planned Enablement Date">
			<div class="input-filter-group">
				<ng-select [items]="migrationDateFilterOpts"
				           [(ngModel)]="selectedEnableDateFilterOpt"
				           bindLabel="label"
				           bindValue="value"
				           [attr.data-identifier]="'organization-site-filter-enablement-date-select'"
				           placeholder="Any">
				</ng-select>
			</div>
		</lib-filter-pill>
	</div>
</ng-container>
